export enum ImportStatus {
  OPEN=0,
  CONFIRMED=1
}
